module.exports = __webpack_public_path__ + "media/images/c-pdfBtn/icon-4e0f62d2c648b631f3bef0f2d3e34ead.svg";